export const en = {
  noticeBanner: {
    days_until: 'Only {{days}} days until <bold>{{eventName}}</bold>!',

    submit_request: 'Submit a request to volunteer',
    black_history_month: 'Honour <bold>Black History Month</bold> with action! Request an event today.',
  },
}
